import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function atendimentoPosto(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@atendimentoPosto/FIND_DATA':
      case '@atendimentoPosto/UPDATE_DATA':
      case '@atendimentoPosto/DELETE_DATA':
      case '@atendimentoPosto/STORE_DATA':
      case '@atendimentoPosto/DATA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@atendimentoPosto/SUCCESS_REMOVE':
      case '@atendimentoPosto/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@atendimentoPosto/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.data;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@atendimentoPosto/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.data;
        break;
      }

      case '@atendimentoPosto/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
